<template>
  <SystemDate class="border-[1px] border-solid font-Spectral" :aria-selected="isSelected" :class="['border-transparent', noCursor ? 'hover:cursor-auto' : 'cursor-pointer']">
    <template #day>
      <AtomsParagraph4 class="relative flex items-center justify-center">
        <span class="font-Spectral text-[16px] font-bold md:text-[17px]" :class="[{ 'opacity-30': !isAvailable }, dateHighlightClass]">
          {{ dayOfMonth }}
        </span>
        <span
          v-if="availabilityStatus === 'FULL'"
          class="absolute left-0 right-0 top-1/2 h-[1px] w-full -translate-y-1/2 border-t border-black1 opacity-30"
          :class="[{ 'border-red3': youbi === SUN_INDEX }, { 'border-blue2': youbi === SAT_INDEX }]"
        ></span>
      </AtomsParagraph4>
    </template>
  </SystemDate>
</template>

<script setup lang="ts">
import type { AvailabilityStatus } from '@/models/wabunka/view/experience/wabunkaExperienceCalendar';
import { SUN_INDEX, SAT_INDEX } from '@/wabunka-src/constants/calendar';

import type dayjs from 'dayjs';

interface Props {
  day: dayjs.Dayjs;
  isSelected?: boolean;
  disabled?: boolean;
  availabilityStatus: AvailabilityStatus | undefined;
}

const props = withDefaults(defineProps<Props>(), {
  disabled: false,
});

const isAvailable = computed<boolean>(() => props.availabilityStatus === 'CONFIRMED_INSTANTLY' || props.availabilityStatus === 'ON_REQUEST');

const dayOfMonth = computed<number>(() => props.day.date());

const dateHighlightClass = computed<string>(() => {
  if (props.availabilityStatus === 'CONFIRMED_INSTANTLY' || props.availabilityStatus === 'ON_REQUEST') {
    // 四角（リクエスト予約）38px / 丸（即時予約）42px
    const bgClass = props.isSelected ? 'bg-gold3 text-white hover:bg-gold3/90' : 'bg-white border-[0.5px] border-gold3 hover:bg-black/5';
    const shapeClass = props.availabilityStatus === 'CONFIRMED_INSTANTLY' ? 'rounded-full' : 'rounded-sm';
    const sizeClass = props.availabilityStatus === 'CONFIRMED_INSTANTLY' ? 'min-w-[42px] min-h-[42px]' : 'min-w-[38px] min-h-[38px]';
    return `${bgClass} ${shapeClass} ${sizeClass} inline-flex items-center justify-center`;
  }
  return '';
});

const youbi = props.day.day();
const noCursor = computed<boolean>(() => props.disabled || props.availabilityStatus === 'UNAVAILABLE');
</script>
